import { createReducer, Action, on } from '@ngrx/store';

import { SearchActions } from './search.actions';
import { SearchState } from './search.state';
import { measureReducer } from '../../features/shared/utils/runtime-reducer-stats';
import { AppActions } from '../app/app.actions';

export const initialState: SearchState = {
  loading: false,
};

const featureReducer = measureReducer(
  createReducer(
    initialState,
    on(
      SearchActions.Search,
      (state, action): SearchState => ({
        ...state,
        loading: true,
        error: undefined,
        term: action.filter,
      })
    ),
    on(
      SearchActions.SearchSuccess,
      (state, action): SearchState => ({
        ...state,
        loading: false,
        results: {
          checklists: action.results.checklists,
          definedTerms: action.results.definedTerms,
          datapointFields: action.results.datapointFields,
          datapointRules: action.results.datapointRules,
          managerIds: action.results.managerIds,
          topics: action.results.topics,
          transactionIds: action.results.transactionIds,
        },
      })
    ),
    on(
      SearchActions.SearchFail,
      (state, action): SearchState => ({ ...state, loading: false, error: action.error })
    ),
    on(
      SearchActions.Clear,
      (state, action): SearchState => ({ ...state, loading: false, results: undefined })
    ),
    on(
      SearchActions.SetRecentSearches,
      (state, action): SearchState => ({ ...state, recentSearches: action.recentSearches || [] })
    ),
    on(
      AppActions.LoadInitDataSuccess,
      (state, action): SearchState => ({
        ...state,
        recentSearches: action.data?.assetSettings?.recentSearches || [],
      })
    )
  )
);

export function reducer(state: SearchState | undefined, action: Action) {
  return featureReducer(state, action);
}
